import {Box} from "@mui/material";

const styles = {
    container: {
        paddingBottom: '0.2rem'
    },
    controlsRow: {
        display: {xs: 'flex', md: 'contents'},
        justifyContent: {xs: 'space-between', md: 'normal'},
        alignItems: {xs: 'center', md: 'normal'},
        paddingBottom: {xs: '0.2rem', md: '0rem'},
        order: {xs: 1, md: 0}
    },
    titleContent: {
        textAlign: 'center',
        paddingBottom: {xs: '0.2rem', md: '0rem'},
        position: {xs: 'static', md: 'absolute'},
        left: {xs: 'auto', md: '50%'},
        transform: {xs: 'none', md: 'translateX(-50%)'},
        order: {xs: 2, md: 1}
    },
    contextOptions: {
        display: {xs: 'contents', md: 'block'},
        order: {xs: 0, md: 2}
    }
};

const parentContainerStyle = {
    ...styles.container,
    display: {xs: 'block', md: 'flex'},
    position: {xs: 'static', md: 'relative'},
    justifyContent: {xs: 'normal', md: 'space-between'},
    alignItems: {xs: 'normal', md: 'center'}
};

export default function CalendarHeaderLayout({ actionPanelContainer, titleContainer, contextOptionContainer }) {
    return (
        <Box sx={parentContainerStyle}>
            <Box sx={styles.controlsRow}>
                {actionPanelContainer}
                <Box sx={styles.contextOptions}>{contextOptionContainer}</Box>
            </Box>
            <Box sx={styles.titleContent}>{titleContainer}</Box>
        </Box>
    );
}